module.exports = __webpack_public_path__ + "media/images/lb/110-a671d35cf08b1d8384ee719a12cdf968.svg";